<template>
   <div class="crud-wrapper">
      <crud-toolbar
              :modal-mode="modalMode"
              :new-state="newState"
              :title="modalTitle"
              @onCommand="toolbarCommand"
      ></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">
         <v-layout row wrap>
            <a-text-field label="Nome" sm6 v-model="formData.name"></a-text-field>
            <a-text-field
                    autofocus
                    label="CPF"
                    sm6
                    v-mask="'###.###.###-##'"
                    v-model="formData.federalId"
                    disabled
            ></a-text-field>
            <a-text-field label="Endereço" text-transform="capitalize" sm8 v-model="formData.address"></a-text-field>
            <a-text-field label="CEP" mask="#####-###" sm4 v-model="formData.zipcode"></a-text-field>
            <a-text-field label="Cidade" v-model="formData.city" sm6></a-text-field>
            <a-text-field label="Estado" v-model="formData.state" sm2></a-text-field>
            <a-date-field label="Nascimento" dateFormat="DD/MM/YYYY" v-model="formData.birth" sm4></a-date-field>
            
            <a-select-field label="Situação" obj="userStatus" v-model="formData.userStatusId" sm12></a-select-field>
            <a-text-area-field v-if="formData.userStatusId == 3" label="Notas (Para o Afiliado)" v-model="formData.statusNotes" sm12></a-text-area-field>
         </v-layout>

         <template slot="rightContent">
            <v-card class="mb-4" color="rgba(0,0,0, 0.03)" flat style="margin-top: -10px; border-radius:12px;">
               <v-card-title>Documentos do Afiliado</v-card-title>
    
               <v-card-text v-if="cloudinaryImages.length == 0" class="text-xs-center">Documentos ainda não anexados
               </v-card-text>
               <viewer v-if="cloudinaryImages.length != 0" :images="cloudinaryImages">
                  <img style="max-height:200px; margin: 0px 5px; border-radius:8px;" v-for="src in cloudinaryImages"
                       :src="src.file" :key="src.file"/>
               </viewer>
            </v-card>
         </template>
      </crud-form>
   </div>
</template>
<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';
    import 'viewerjs/dist/viewer.css';

    export default CrudFormClass.extend({
        name: 'PendingAppUsersForm',

        data () {
            return {
                title: 'Validação Cliente',
                formName: 'pendingAppUserForm',

                cloudinaryImages: [],

                formData: {
                    id: null,
                    address: null,
                    zipcode: null,
                    federalId: null,
                    name: null,
                    birth: null,
                    city: null,
                    state: null,
                    createdAt: null,
                    userStatusId: null,
                    userStatusName: null,
                    statusNotes: null,
                    file: null,
                }
            };
        },

        watch: {
            'formData.id': async function (value) {
                this.cloudinaryImages = await this.$api.dataService.execute('affiliateDocs/getById', { id: value });
            }
        },

        computed: {
            formatedDate () {
                return this.$moment(this.formData.createdAt).format('DD/MM/YYYY hh:mm');
            },
            cloudinaryImages () {
                let files = this.formData.file || [];
                return files.map(el => this.$config.imageUri(`${el.file.file}.jpg`, 'photoBigger'));
            },
            covenantNames () {
                return this.formData.enrollments.map(e =>
                    Object({
                        text: e.covenantName,
                        value: e.covenantId
                    })
                );
            }
        },
    });
</script>

<style scoped>
    .harpia, .acert {
        background-color: #f5f5f5;
        padding: 10px 17px;
        margin-bottom: 20px;
    }

    .harpia > div:first-child, .acert > div:first-child {
        display: flex;
        flex-direction: row;
        margin-bottom: 3px;
    }

    .harpia-title, .acert-title {
        margin: 0;
        color: #555555;
        font-weight: bold;
    }

    .harpia-description, .acert-description {
        margin: 0;
        margin-left: 10px;
        color: #e94343;
        font-weight: bold;
    }

    .harpia-substatus, .acert-substatus {
        margin: 0;
        background-color: white;
        border-radius: 5px;
        padding: 15px;
    }

    .harpia-substatus-description {
        margin: 0;
        font-size: 14px;
        color: #9e9e9e;
        margin-bottom: 5px;
    }

    .harpia-reasons, .acert-substatus {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 15px;
    }

    .harpia-reasons:last-child {
        margin-bottom: 0;
    }

    .harpia-reasons > i, .acert-substatus > i {
        color: #e94343;
    }

    .harpia-reasons > div, .acert-substatus > div {
        margin-left: 5px;
    }

    .harpia-reasons-description, .acert-reason {
        margin: 0;
        font-weight: bold;
        color: #555555;
    }

    .harpia-reasons-note, .acert-text-reason {
        margin: 0;
        color: #9e9e9e;
    }
</style>


// WEBPACK FOOTER //
// src/pages/PendingAffiliatesForm.vue